import React from 'react'
import classnames from 'classnames/bind'

// Libs
import { fetchMerchantProductList } from '@/api/fetchMerchantProductList'
import { useProductContentList } from '@/components/pages/User/hooks/useProductContentList'

// Components
import MallList from '@/components/shared/MallList'

// constants
import { GtmItemListName } from '@/constants/gtmEvent'
import { MALL_DEFAULT_PAGE_SIZE } from '@/constants/mall'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const ProductContent = ({ merchantId, isDrawer }: { merchantId: number; isDrawer?: boolean }) => {
  const { categoryListData } = useProductContentList({
    fetchDataApi: fetchMerchantProductList,
    merchantId,
    defaultPayload: { pageSize: MALL_DEFAULT_PAGE_SIZE, categoryId: null },
  })

  return (
    <div className={cx('productContent', { isDrawer })}>
      <MallList
        className={cx('productContent-list')}
        categoryListData={categoryListData}
        gtmItemEventParams={{
          itemListName: `${GtmItemListName.MERCHANT}`,
          itemListId: `${merchantId}`,
        }}
      />
    </div>
  )
}

export default ProductContent
